import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';
import { AppCommonModule } from '@shared/modules';
import { RecaptchaHintComponent } from './recaptcha-hint/recaptcha-hint.component';
import { RecaptchaComponent, RECAPTCHA_SITE_KEY } from './recaptcha.component';


@NgModule({
  declarations: [
    RecaptchaComponent,
    RecaptchaHintComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxCaptchaModule,
    AppCommonModule
  ],
  exports: [
    RecaptchaComponent,
    RecaptchaHintComponent
  ]
})
export class RecaptchaModule {
  static forRoot(siteKey: string): ModuleWithProviders<RecaptchaModule> {
    return {
      ngModule: RecaptchaModule,
      providers: [
        { provide: RECAPTCHA_SITE_KEY, useValue: siteKey }
      ]
    }
  }
}
